import { ReactElement } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconDefinition } from "@fortawesome/free-solid-svg-icons"

import { ContextMenuItem } from "@wfp/ui"

import PermissionWrapper from "../Common/PermissionWrapper"

type Props = {
  permissions: {
    moduleId: number | number[]
    subModule: string
  }
  onAction: () => void
  feature: string
  label: string
  icon: IconDefinition
  color: string
  disabled?: boolean
}

const ContextItem = ({
  permissions,
  onAction,
  feature,
  label,
  icon,
  color,
  disabled = false,
}: Props): ReactElement | null => {
  if (disabled) return null

  return (
    <PermissionWrapper {...permissions} feature={feature}>
      <ContextMenuItem className="p-1.5 px-2 text-left w-40 hover:bg-slate-200" onClick={onAction}>
        <div>
          <FontAwesomeIcon icon={icon} color={color} className="mr-1 min-w-[1rem]" />
          <span style={{ color }}>{label}</span>
        </div>
      </ContextMenuItem>
    </PermissionWrapper>
  )
}

export default ContextItem
